var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex justify-center pa-0 flex-wrap statistics_wrap",attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"container__wrap"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }